import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterface, discountSectionsInterface} from "./discounstInterface";
import {
  setCustomAddedDiscounts,
  setDiscountSections,
  setFinanceActiveDiscount
} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import DiscountNestedChild from "./discountNestedChild";
import uuid from "uuid";
import {getNextCustomDiscountOrder, shouldUseMultipleWorkSheets} from "./discountFunctions";
import store from "../../store";

class DiscountNestedParent extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  componentDidMount() {
    this.ensureCustomAddedDiscountForActiveQuote();
  }

  componentDidUpdate(prevProps) {
    // rooms are switched by changing activeQuoteIndex while this component stays mounted,
    // so re-run the same bootstrap for the newly active room in case it doesn't have its own entry yet
    if (prevProps.activeQuoteIndex !== this.props.activeQuoteIndex) {
      this.ensureCustomAddedDiscountForActiveQuote();
    }
  }

  ensureCustomAddedDiscountForActiveQuote = () => {
    const {discountSection, setCustomAddedDiscounts, activeQuoteIndex} = this.props;
    const customAddedDiscounts = store.getState().priceWorksheetState.customAddedDiscounts; // get every time latest
    const filteredCustomDiscounts = customAddedDiscounts.filter(discount => this.nestedDiscountIsVisible(discount));

    if (!filteredCustomDiscounts.some(discount => discount.nestedParent && (discount.nestedParent === this.props.discount.uuId))) {
      const allNested = discountSection.discounts.filter(dis => dis.nestedParent && (dis.nestedParent === this.props.discount.uuId));
      if (!allNested.length) {
        return
      }
      const uuIdId = uuid();
      setCustomAddedDiscounts([...customAddedDiscounts, Object.assign({}, allNested[0], {
        categoryId: discountSection.id,
        id: uuIdId,
        uuId: uuIdId,
        order: getNextCustomDiscountOrder(this.props.discount),
        quoteIndex: activeQuoteIndex,
      })]);
      this.props.setDiscountSections([...this.props.discountSections]); // update all price components
    }
  }

  nestedDiscountIsVisible = (discount) => {
    const {activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    return !hasMultipleWorkSheets || discount.quoteIndex === activeQuoteIndex
  }

  render() {
    const {discountSection, customAddedDiscounts} = this.props;
    const nestedOptions = [
      {isEmpty: true},
      ...discountSection.discounts.filter(dis => dis.nestedParent && (dis.nestedParent === this.props.discount.uuId))
    ];
    if (nestedOptions.length === 1) {
      return null // just in case, cases when there is only empty option
    }
    const allSelectedNested = customAddedDiscounts.filter(discount => {
      return discount.nestedParent && (discount.nestedParent === this.props.discount.uuId)
        && this.nestedDiscountIsVisible(discount)
    });

    // console.log("allSelectedNested", allSelectedNested);

    return (
      <Fragment>
        {allSelectedNested.map((nestedChild, nestedChildIndex) => {
          return <DiscountNestedChild key={nestedChild.uuId}
                                      discount={nestedChild}
                                      parentDiscount={this.props.discount}
                                      nestedChildIndex={nestedChildIndex}
                                      nestedOptions={nestedOptions}
                                      allSelectedNested={allSelectedNested}
                                      discountSection={discountSection}/>
        })}
      </Fragment>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, workSheetsCount, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;
  const {showAllQuotesCartItemsList} = store.cartState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    fabricatorData: store.fabricatorState,
    // Total requirements end
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    quotes,
    workSheetsCount,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financeActiveDiscount,
    showAllQuotesCartItemsList,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setCustomAddedDiscounts,
  setFinanceActiveDiscount,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountNestedParent);
